import { IsObjectEmpty, IsStringEmpty, Log } from "../utilities/CommonMethods";
import { APICodes } from "./APICodes";
// import { ParsedError } from "./DataParser";

const signUpErrorList = (err) => {
    Log('Returning SignUp Err List for ', err);
    return {
        username: err.username,
        email: err.email
    };
}

const signInErrorList = (err) => {
    Log('Returning SignIn Err List for ', err);
    return {
        password: err.password,
    };
}

const getEditProfileErrorList = (err) => {
    Log('Returning Get Edit Profile List => ', err);
    return {
        'username': err.username,
        'email': err.email,
        'phone': err.phonenumber,
        'channelName': err.title,
        'firstname': err.first_name,
        'lastname': err.last_name,
        'tagline': err.tagline,
        'bio': err.aboutme,
        'expertise': err.expertise,
        'github': err.github,
        'linkedIn': err.linkedin,
        'twitter': err.twitter,
        'website': err.website
    }
}

const getCreateVideoErrorList = (err) => {
    Log('Returning Get Edit Profile List => ', err);
    if (IsObjectEmpty(err.thumbnail)) {
        return {};
    }
    return {
        thumbnail: err.thumbnail
    }
}

const getErrorList = (err, apiCode) => {
    Log('Getting Error List for ', err);
    let parseError = {};
    switch (apiCode) {
        case APICodes.SIGN_UP:
            parseError = signUpErrorList(err);
            break;
        case APICodes.SIGN_IN:
            parseError = signInErrorList(err)
            break;
        case APICodes.EDIT_PROFILE_DATA:
            parseError = getEditProfileErrorList(err);
            break;
        case APICodes.UPDATE_LEARNING_ENABLER:
            parseError = getEditProfileErrorList(err);
            break;
        case APICodes.UPDATE_LEARNER:
            parseError = getEditProfileErrorList(err);
            break;
        case APICodes.CREATE_VIDEO:
            parseError = getCreateVideoErrorList(err);
            break;
        default:
            parseError = {};
    }
    return parseError;
}

const errorModel = (err, apiCode) => {
    Log('Error Obj List', err.data);
    const errorList = !IsObjectEmpty(err.data) ? getErrorList(err.data, apiCode) : [];
    if (apiCode === APICodes.VERIFY_EMAIL) {
        return {
            status: err.status,
            message: err.data.error,
            linkExpired: err.data.expired,
            errorList: errorList
        }
    } else if (apiCode === APICodes.RESET_PASSWORD) {
        return {
            status: err.status,
            message: err.data.message,
            errorList: errorList
        }
    } else {
        return {
            status: err.status,
            message: !IsStringEmpty(err.data.error) ? err.data.error : err.data.message,
            errorList: errorList
        }
    }
}

const ParsedErrorObject = (error, apiCode) => {
    if (!IsObjectEmpty(error.response)) {
        return (errorModel(error.response, apiCode));
    }
    return {};
}

export { ParsedErrorObject };